import React, {useContext} from "react";
import DescriptionIcon from '@mui/icons-material/Description';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import TwoWheelerIcon from '@mui/icons-material/TwoWheeler';
import HouseIcon from '@mui/icons-material/House';
import LocalHospital from '@mui/icons-material/LocalHospital';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import ComputerIcon from '@mui/icons-material/Computer';
import Tooltip from '@mui/material/Tooltip';
import AdviserContext from "../../../../context/AdviserContext";


const SidebarMenuItems = () => {
    const {productScope} = useContext(AdviserContext);

    const cotizarProductsDict = {
        "vehiculo" : {
            title: "Automotor",
            index: 1.1,
            icon: (
                <Tooltip title="Cotizar Automotor" placement="right">
                    <DirectionsCarIcon style={{color: "#3D4977"}}/>
                </Tooltip>
            ),
            items: []
        },
        "motovehiculo" : {
            title: "Motovehículo",
            index: 1.2,
            icon: (
                <Tooltip title="Cotizar Motovehículo" placement="right">
                    <TwoWheelerIcon style={{color: "#3D4977"}}/>
                </Tooltip>
            ),
            items: []
        },
        "combinado":  {
            title: "Hogar",
            icon: (
                <Tooltip title="Cotizar Hogar" placement="right">
                    <HouseIcon style={{color: "#3D4977"}}/>
                </Tooltip>
            ),
            index: 1.3,
            items: []
        },
        "microseguro": {
            title: "Microseguro",
            icon: (
                <Tooltip title="Cotizar Microseguro" placement="right">
                    <ComputerIcon style={{color: "#3D4977"}}/>
                </Tooltip>
            ),
            index: 1.4,
            items: []
        }
    }

    const documentacionProductosDict = {
        "vehiculo": {
            title: "Automotor",
            icon: (
                <Tooltip title="Documentación Automotor" placement="right">
                    <DirectionsCarIcon style={{color: "#3D4977"}}/>
                </Tooltip>
            ),
            index: 2.1,
            items: []
        },
        "motovehiculo": {
            title: "Motovehículo",
            icon: (
                <Tooltip title="Documentación Motovehículo" placement="right">
                    <TwoWheelerIcon style={{color: "#3D4977"}}/>
                </Tooltip>
            ),
            index: 2.2,
            items: []
        },
        "combinado": {
            title: "Hogar",
            icon: (
                <Tooltip title="Documentación Hogar" placement="right">
                    <HouseIcon style={{color: "#3D4977"}}/>
                </Tooltip>
            ),
            index: 2.3,
            items: []
        },
        "microseguro": {
            title: "Microseguro",
            icon: <Tooltip title="Documentación Microseguro" placement="right"><ComputerIcon
                style={{color: "#3D4977"}}/></Tooltip>,
            index: 2.4,
            items: []
        },
        "otros": {
            title: "Otros Seguros",
            icon: <Tooltip title="Documentación Otros Seguros" placement="right"><VolunteerActivismIcon
                style={{color: "#3D4977"}}/></Tooltip>,
            index: 2.5,
            items: []
        },
        "prevencion": {
            title: "Prevención Salud",
            icon: <Tooltip title="Documentación Prevención Salud" placement="right"><LocalHospital
                style={{color: "#3D4977"}}/></Tooltip>,
            index: 2.6,
            items: []
        }
    }

    let menu = [
        {
            icon: (
                <Tooltip title="Panel de trabajo" placement="right">
                    <DashboardIcon style={{color: "#3D4977"}}/>
                </Tooltip>
            ),
            title: "Dashboard",
            index: 0,
            items: []
        },
        {
            icon: (
                <Tooltip title="Cotizar" placement="right">
                    <UploadFileIcon style={{color: "#3D4977"}}/>
                </Tooltip>
            ),
            title: "Cotizar",
            index: 1,
            items: []
        },
        {
            icon: (
                <Tooltip title="Documentación" placement="right">
                    <DescriptionIcon style={{color: "#3D4977"}}/>
                </Tooltip>
            ),
            title: "Documentación",
            index: 2,
            items: []
        }
    ]

    menu.map((item) => {
        if (item.title === "Cotizar") {
            Object.keys(cotizarProductsDict).map(product => {
                if (productScope.includes(product)) {
                    item.items.push(cotizarProductsDict[product])
                }
            })
        }
        if (item.title === "Documentación") {
            Object.keys(documentacionProductosDict).map(product => {
                if (productScope.includes(product)) {
                    item.items.push(documentacionProductosDict[product])
                }
            })
        }
        return item
    })

    return menu;
}

export {SidebarMenuItems};